export default {
	SET_DATA: "temp_data/SET_DATA"
}